import { PDFDownloadLink } from "@react-pdf/renderer";
import { format } from "date-fns";
import { useHistory } from "react-router-dom";
import downloadIcon from "../../../assets/img/download-icon.svg";
import { InvoiceDocument } from "../../../components";
import { Card } from "../../../components/card.component";
import { AppRouteUi } from "../../../config/appRoute";
import { ApiSchemaBillingInvoices } from "../../../models/api";
import { UtilityDate } from "../../../utils";

export function PageViewInvoice() {
  const history = useHistory<ApiSchemaBillingInvoices>();
  const data = history.location.state;
  const modifiedData = (() => {
    const updatedData = { ...data };
    updatedData.billingDate = format(new Date(data.billingDate), "PP");
    updatedData.dueDate = format(
      UtilityDate.getDateAfterThirtyDays(data.billingDate),
      "PP"
    );
    return updatedData;
  })();

  return (
    <Card
      header={
        <div className="row align-items-center justify-content-between">
          <div className="col-md-8 col-12 content-box-title">
            <div className="d-flex align-items-center">
              <div
                onClick={() => {
                  history.push(AppRouteUi.Billing.Invoice());
                }}
                className="pe-2 border-2 border-end click text-green-200"
              >
                <i className="fas fa-arrow-left text-green-200" />
              </div>
              <p className="text-capitalize ps-2 text-green-200">
                {modifiedData.documentId}
              </p>
            </div>
          </div>
          <div className="col-4">
            <div className="search-component justify-content-end">
              <PDFDownloadLink
                document={<InvoiceDocument data={modifiedData} />}
                fileName={`${modifiedData.documentId || "invoice"}.pdf`}
                style={{ width: "20px" }}
                className="btn search-filter-btn me-3"
              >
                <img
                  src={downloadIcon}
                  alt="filter-panel-icon"
                  className="img-fluid svg-btn"
                />
              </PDFDownloadLink>
            </div>
          </div>
        </div>
      }
    >
      <p className="mb-2 fs-6 fw-bold">Invoice Summary</p>
      <div className="row p-3">
        <div className="col col-6 col-6">
          <div className="row">
            <div className="col">
              <p>Billing cycle :</p>
              <p>Invoice date :</p>
            </div>
            <div className="col">
              <p className="text-end">Monthly</p>
              <p className="text-end">{modifiedData.billingDate}</p>
            </div>
          </div>
        </div>
        <div className="col col-6 col-6">
          <p className="text-end">Due on: {modifiedData.dueDate}</p>
        </div>
      </div>

      <div className="mt-3">
        <p className="mb-2 fs-6 fw-bold">Items in your invoice</p>
        <table className="table" id="billing-table">
          <thead>
            <tr>
              <th>Item</th>
              <th>Quantity</th>
              <th>Price</th>
              <th>Total</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{modifiedData.title}</td>
              <td>{modifiedData.quantity}</td>
              <td>$ {modifiedData.price}</td>
              <td>$ {modifiedData.billedAmount}</td>
            </tr>
          </tbody>
        </table>

        <div className="text-end" id="invoice-summary">
          <p>Subtotal: $ {modifiedData.billedAmount}</p>
          <p>Taxes: $ 0.00</p>
          <p className="fw-bold">Total: $ {modifiedData.billedAmount}</p>
        </div>
      </div>
    </Card>
  );
}
